import styled from 'styled-components';
import { device } from '../../mediaQuery';

export const LandingContainer = styled.div`
	height: 100vh;
	width: 100%;
	background: linear-gradient(50deg, rgba(0, 0, 0, 0.5) 0%, rgba(255, 0, 0, 0.5) 100%),
		url('https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1498&q=80');
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow-y: hidden;
`;
export const Content = styled.div`
	height: 100%;
	max-height: 400px;
	max-width: 800px;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;

	.home-link-btn {
		margin-top: 30px;
	}
`;

export const Title = styled.div`
	font-size: var(--fontXXL);
	font-weight: var(--fontSuperBold);
	text-align: center;
	color: var(--colorWhite);
	padding: 0 10px;
	text-transform: capitalize;
	width: 270px;

	@media ${device.tablet} {
		font-size: calc(var(--fontXXL) * 1.5);
		width: 500px;
	}
`;

export const Button = styled.button`
	height: 50px;
	width: 150px;
	border-radius: 10px;
	font-size: var(--fontS);
	font-weight: var(--fontBold);
	border: none;
	cursor: pointer;
	text-transform: uppercase;
	color: var(--colorWhite);
	background-color: var(--colorBlack);

	:hover {
		background-color: var(--colorWhite);
		color: var(--colorBlack);
	}
`;
